import React, { memo } from "react";
import {
    ChargeHeader,
    ModalOverlay,
    ModalContent,
    CTAContainer,
    StyledHeaderText,
    PopupInnerButtonsContainer,
    ButtonWidth,
    StyledButton,
} from "./styles";
import { CONFIRM_SETTLE_BILL, GO_AHEAD, GO_BACK, GO_BACK_KEY, SETTLE_KEY } from "@dineout-cart-ui/constants/index";
import { PAYMENT_CART_HEADER } from "@swiggy-private/cart-test-ids";

interface ISettleMyBillPopup {
    onSettleBillPress: () => void;
    onClose: () => void;
    isVisible: boolean;
}

const SettleMyBillPopup: React.FC<ISettleMyBillPopup> = ({ onClose, onSettleBillPress, isVisible }) => {
    if (!isVisible) return null;

    return (
        <ModalOverlay>
            <ModalContent>
                <ChargeHeader data-testid={PAYMENT_CART_HEADER.SETTLE_BILL_POPUP_HEADER}>
                    <StyledHeaderText variant="V2.body2.neutral.bold" color="text_Highest_Emphasis">
                        {CONFIRM_SETTLE_BILL}
                    </StyledHeaderText>
                </ChargeHeader>
                <CTAContainer>
                    <PopupInnerButtonsContainer>
                        <ButtonWidth key={GO_BACK_KEY} tabIndex={0}>
                            <StyledButton
                                variant="secondary"
                                onClick={onClose}
                                height={50}
                                data-testid={PAYMENT_CART_HEADER.SETTLE_BILL_POPUP_BACK}
                            >
                                {GO_BACK}
                            </StyledButton>
                        </ButtonWidth>

                        <ButtonWidth key={SETTLE_KEY} tabIndex={1}>
                            <StyledButton
                                variant="primary"
                                onClick={onSettleBillPress}
                                height={50}
                                data-testid={PAYMENT_CART_HEADER.SETTLE_BILL_POPUP_PRESS}
                            >
                                {GO_AHEAD}
                            </StyledButton>
                        </ButtonWidth>
                    </PopupInnerButtonsContainer>
                </CTAContainer>
            </ModalContent>
        </ModalOverlay>
    );
};

export default memo(SettleMyBillPopup);
